<template>
    <div class="mt-3">
        <h2>Email Templates</h2>

        <button class="btn btn-primary" @click="newEmailTemplateClick">New Email Template</button>


        <table class="table table-sm mt-3">
            <thead>
            <tr>
                <th>Subject</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="emailTemplate in emailTemplates">
                <td>
                    <a href="javascript:void(0)" @click="onEditClick(emailTemplate)">
                        {{emailTemplate.subject}}
                    </a>
                </td>
                <td>
                    <a href="javascript:void(0)" @click="onDeleteClick(emailTemplate)">
                        <i class="fad fa-times-circle text-secondary"></i>
                    </a>
                </td>
            </tr>
            </tbody>
        </table>

        <email-template-modal key="emailTemplatesModal" v-if="showEmailTemplateModal"
                              :email-template="currentEmailTemplate"
                              :yes-event="reloadEmailTemplates"
                              @noEvent="showEmailTemplateModal = false"></email-template-modal>

        <confirm-modal
                v-if="showConfirmModal"
                @noEvent="showConfirmModal = false"
                :yesEvent="deleteEmailTemplate"
                text="Are you sure you want to delete this email template?">
        </confirm-modal>
    </div>
</template>

<script>
    import EmailTemplatesService from "../services/EmailTemplatesService";
    import EmailTemplateModal from "./EmailTemplateModal.vue";
    import ConfirmModal from "../components/ConfirmModal.vue";

    export default {
        name: 'EmailTemplates',
        components: {ConfirmModal, EmailTemplateModal},
        props: ['prop1', 'prop2'],
        data() {
            return {
                model: webase.model,
                emailTemplates: [],
                service: new EmailTemplatesService(),
                showEmailTemplateModal: false,
                reloadEmailTemplates: function () {
                },
                currentEmailTemplate: {
                    id: null,
                    subject: '',
                    app_id: null,
                    body: ''
                },
                showConfirmModal: false,
                deleteEmailTemplate: function () {
                }
            }
        },
        mounted() {
            this.loadTemplates()
        },
        methods: {
            loadTemplates() {
                this.service.list().then((response) => {
                    this.emailTemplates = response
                }).catch((message) => {
                    console.log('error loading email templates')
                    console.log(message)
                })
            },
            newEmailTemplateClick() {
                this.currentEmailTemplate = {
                    id: null,
                    subject: '',
                    app_id: this.model.app.id,
                    body: ''
                }

                this.showEmailTemplateModal = true

                this.reloadEmailTemplates = () => {
                    this.loadTemplates()
                }
            },
            onDeleteClick(emailTemplate) {
                this.showConfirmModal = true
                this.deleteEmailTemplate = () => {
                    this.service.remove(emailTemplate.id).then((response) => {
                        this.showConfirmModal = false
                        webase.utils.array.remove(this.emailTemplates, emailTemplate.id)
                    }).catch((message) => {
                        console.log('error deleting email template')
                        console.log(message)
                        this.showConfirmModal = false
                    })
                }
            },
            onEditClick(emailTemplate) {
                this.currentEmailTemplate = emailTemplate
                this.showEmailTemplateModal = true

                this.reloadEmailTemplates = () => {
                    this.loadTemplates()
                }
            }
        }
    }
</script>

<style>

</style>
